module.exports = {
  Days: 'วัน',
  Weeks: 'สัปดาห์',
  Months: 'เดือน',
  CurrentlySelected: '(ตัวเลือกปัจจุบัน)',
  CurrentPage: '(หน้าปัจจุบัน)',
  NonTicketSettlement: 'ไม่ใช้ตั๋ว',
  TicketSettlement: 'ใช้ตั๋ว',
  MonthlySettlement: 'ปิดเดือน',
  WeeklySettlement: 'ปิดสัปดาห์',
  Monthly: 'ทุกเดือน',
  Day: 'วัน',
  CreditControl: 'ควบคุมเครดิต',
  All: 'ทั้งหมด',
  PleaseSelectAPartner: 'กรุณาเลือกพันธมิตร',
  InvoiceDate: 'วันที่ออกใบแจ้งหนี้',
  BusinessDate: 'วันที่ทำธุรกิจ',
  BillingDate: 'วันที่ออกบิล',
  CostFinancialDate: 'วันที่บันทึกค่าใช้จ่ายทางการเงิน',
  System: 'ระบบ',
  PleaseASpecialApprovalBusiness: 'กรุณาเลือกธุรกิจที่ขออนุมัติพิเศษ',
  SpecialApprovalSuccessful: 'อนุมัติพิเศษสำเร็จ',
  CancelledSpecialApprovalSuccessful: 'ยกเลิกอนุมัติพิเศษสำเร็จ',
  OceanShipping: 'การขนส่งทางทะเล',
  PleaseFillInTheContact: 'กรุณากรอกข้อมูลผู้ติดต่อ!',
  Other: 'อื่นๆ',
  CustomerType: 'ประเภทลูกค้า',
  CustomerContactChannel: 'ช่องทางติดต่อลูกค้า',
  DueBePrintedOrNeeded: 'เนื่องจากเกินเกณฑ์ควบคุมเครดิต ตั๋วนี้ถูกระงับ ไม่สามารถพิมพ์หรือส่ง EDI ได้ กรุณาติดต่อผู้ดูแลเพื่อปลดล็อกเมื่อต้องการใช้',
  DearCustomersAssociatedWith: 'คุณสามารถเลือกได้เฉพาะลูกค้าที่เกี่ยวข้องกับการขายเท่านั้นนะคะ (⊙o⊙)',
  CharacterTooLongPleaseAgain: 'ความยาวตัวอักษรเกินกำหนด กรุณากรอกใหม่!',
  ShippingTypeCannotBeEmpty: 'ประเภทการขนส่งต้องไม่ว่างเปล่า',
  FullhalfJourneyCannotBeEmpty: 'เต็มเส้นทาง/ครึ่งเส้นทางต้องไม่ว่างเปล่า',
  RouteCannotBeEmpty: 'เส้นทางเดินเรือต้องไม่ว่างเปล่า',
  PleaseAPieceOfData: 'กรุณาเลือกข้อมูล 1 รายการ!',
  OverdueFees: 'ค่าธรรมเนียมเกินกำหนด',
  OverControllAccountReceivable: 'วัตถุการชำระเงินที่เกินควบคุมเครดิต (ลูกหนี้)',
  Family: 'บ้าน',
  CRMExpiredTip: 'เรียนผู้ใช้ที่เคารพ โมดูล CRM ที่ท่านซื้อหมดอายุแล้ว<br>กรุณาต่ออายุเพื่อใช้งานต่อ สามารถติดต่อพนักงานขายหรือฝ่ายบริการลูกค้า<br><div style="margin-top: 5px;">โมดูล CRM จะถูกจำกัดการเข้าถึง แต่ข้อมูลจะยังคงอยู่ เมื่อต่ออายุแล้วจะสามารถใช้งานได้อีกครั้ง</div>',
  Barge: 'เรือลากจูง',
  SalesInquiryListPage: 'หน้ารายการค้นหาการขาย',
  RemoteBookingListPage: 'หน้ารายการจองระยะไกล'
}
